import Nullable = Common.Nullable;

export type VatFieldErrorKey =
  | "errorVatNumber"
  | "errorVatNumberNoSpaces"
  | "errorVatNumberNotValid"
  | "errorVatNumberDuplicateCompany"
  | "";

export function getVatFieldErrorKey(
  value: Nullable<string>,
  isFormatValid = true,
  isDuplicate = false
): VatFieldErrorKey {
  if (!value) {
    return "errorVatNumber";
  }
  if (/\s/.test(value)) {
    return "errorVatNumberNoSpaces";
  }
  if (!isFormatValid) {
    return "errorVatNumberNotValid";
  }
  if (isDuplicate) {
    return "errorVatNumberDuplicateCompany";
  }
  return "";
}

export function hasVatFieldError(
  value: Nullable<string>,
  isFormatValid = true,
  isDuplicate = false
): boolean {
  return !!getVatFieldErrorKey(value, isFormatValid, isDuplicate);
}
